import { addFavorite } from './addFavorite';
import { removeFavorite } from './removeFavorite';
import {
  EDealType,
  EEntityType,
} from '../../../shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { TAddFavoriteRequest } from '../../../shared/repositories/favorites/v1/add-favorite';
import { TDeleteOfferFromFavoritesRequest } from '../../../shared/repositories/favorites/v1/delete-offer-from-favorites';
import { getGaLabel, getNewbuildingId } from '../../../shared/selectors/newbuilding';
import { IFavoriteActionTypes } from '../../../shared/types/analytics/favorite';
import { TThunkAction } from '../../../shared/types/redux/thunk';

export function changeFavorite(newFavoriteState: boolean, eventActions?: IFavoriteActionTypes): TThunkAction {
  return async (dispatch, getState) => {
    const state = getState();
    const newbuildingId = getNewbuildingId(state);
    const gaLabel = getGaLabel(state);

    const parameters = {
      dealType: EDealType.Sale,
      entityType: EEntityType.Newbuilding,
      entityId: newbuildingId,
    } as TAddFavoriteRequest & TDeleteOfferFromFavoritesRequest;

    const action = newFavoriteState ? addFavorite : removeFavorite;

    dispatch(action(gaLabel, parameters, eventActions));
  };
}
